var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upsell-payment-summary" },
    [
      _vm.step === 0
        ? [
            _vm.getIsPricingVersion3
              ? _c("ChargebeeUpsellSummaryItemsV3", {
                  staticClass: "upsell-payment-summary-subscription"
                })
              : _c("ChargebeeUpsellSummaryItems", {
                  staticClass: "upsell-payment-summary-subscription",
                  attrs: { data: _vm.getSubscriptionItems }
                })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "upsell-payment-summary-incoming" }, [
        _c(
          "h2",
          {
            staticClass:
              "upsell-payment-summary-heading typographies-paragraph-large-semibold"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Abonnement")))]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "typographies-paragraph-large-bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$filters.numberFormatCurrency(
                        _vm.humanizeCentsPrice(
                          _vm.getSubscriptionIncoming.heading.price
                        )
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                    /" +
                      _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                      "\n                "
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "upsell-payment-summary-listing" },
          _vm._l(_vm.getSubscriptionIncoming.items, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass:
                  "upsell-payment-summary-listing__item typographies-paragraph-medium-regular"
              },
              [
                _c(
                  "span",
                  { staticClass: "upsell-payment-summary-listing__item-label" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.label) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "upsell-payment-summary-listing__item-price" },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$filters.numberFormatCurrency(
                                _vm.humanizeCentsPrice(item.price)
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                        /" +
                            _vm._s(_vm.recurrencyLabel(item.recurrence)) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "upsell-payment-summary-invoicing" }, [
        _c(
          "h2",
          {
            staticClass:
              "upsell-payment-summary-heading typographies-paragraph-large-semibold"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Facturable maintenant")))]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "typographies-paragraph-large-bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$filters.numberFormatCurrency(
                        _vm.humanizeCentsPrice(
                          _vm.getSubscriptionInvoicing.heading.price
                        )
                      )
                    ) +
                    "\n                "
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm.getSubscriptionInvoicing.items.length > 0
          ? _c(
              "ul",
              { staticClass: "upsell-payment-summary-listing" },
              _vm._l(_vm.getSubscriptionInvoicing.items, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass:
                      "upsell-payment-summary-listing__item typographies-paragraph-medium-regular"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "upsell-payment-summary-listing__item-label"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.label) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "upsell-payment-summary-listing__item-price"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "typographies-paragraph-medium-semibold"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$filters.numberFormatCurrency(
                                    _vm.humanizeCentsPrice(item.price)
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }